import { ExternalLink } from "lucide-react";

export function EmptyStateCTAs() {
  return (
    <p className="text-xs">
      Can't find what you need?{" "}
      <a
        className="inline-flex items-center gap-1 underline hover:no-underline"
        href="https://docs.arcade.dev/en/home/build-tools/create-a-mcp-server"
        rel="noopener"
        target="_blank"
      >
        Learn how to create an MCP server
        <ExternalLink className="h-3.5 w-3.5" />
      </a>
      , or{" "}
      <a
        className="inline-flex items-center gap-1 underline hover:no-underline"
        href="https://docs.arcade.dev/en/resources/integrations/tool-feedback"
        rel="noopener"
        target="_blank"
      >
        request a tool
        <ExternalLink className="h-3.5 w-3.5" />
      </a>
      .
    </p>
  );
}
